import { Component } from "@angular/core";

@Component({
    selector: "wk-icon-no-records-sprite-pds3",
    templateUrl: "./index.html",
    host: { class: "cg3-host-wk-icon-no-records-sprite" },
})
export class WkIconNoRecordsSpritePds3 {}
